import ReactSelect from 'react-select';

import { shade, transparentize } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  max-width: 1312px;
  margin-right: auto;
  margin-left: auto;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`;

export const OrderContainer = styled.div`
  display: flex;
  justify-content: flex-start;

  button {
    align-items: center;
    display: flex;
    font-size: 1.3rem;
    margin-left: 0.3rem;
    background: transparent;
    color: #fff;

    &:hover {
      color: ${transparentize(0.2, '#fff')};
    }
  }
`;

export const TableContainer = styled.section`
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 2rem auto;
    /* pointer-events: none; */

    tr {
      &:nth-of-type(odd) {
        background: #f3f3f3;
      }

      &:hover {
        color: #166649;
      }

      &:last-child {
        border-bottom: 2px solid #166649;
      }
    }

    th {
      background: ${props => props.theme.primaryColor};
      color: #fff;
      padding: 1.3rem 0.75rem;
      text-align: left;
      font-weight: 500;
      border: 1px solid #166649;
    }

    td {
      position: relative;
      padding: 2rem 0.75rem;
      text-align: left;
      font-size: 16px;
      height: 5rem;

      p {
        cursor: pointer;
        position: relative;

        @media (max-width: 768px) {
          text-align: right;
          cursor: auto;
        }

        .tooltip {
          display: none;
        }

        @media (min-width: 768px) {
          .tooltip {
            display: block;
            visibility: hidden;
            background-color: #fff;
            color: #555;
            border: 1px solid #ccc;
            text-align: center;
            border-radius: 4px;
            padding: 0.6rem 1rem;
            transform: translateY(-20px);
            transition: 0.3s ease-in-out;
            opacity: 0;
            position: absolute;
            z-index: 1;
            text-transform: capitalize !important;
            font-size: 0.9rem;
            bottom: calc(100% + 15px);
            left: -10px;
            box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.1);
            cursor: auto;

            &:after {
              content: '';
              position: absolute;
              bottom: -11px;
              left: 50%;
              margin-top: -5px;
              border-width: 5px;
              border-style: solid;
              border-color: #ccc transparent transparent transparent;
            }
          }

          &:hover .tooltip {
            transform: translateX(0px);
            visibility: visible;
            opacity: 1;
          }
        }
      }

      ul {
        display: flex;
        /* max-width: 100px; */
        flex-wrap: wrap;

        li {
          display: inline-block;

          &:after {
            display: inline-block;
            white-space: pre;
            content: ', ';
          }

          &:last-child:after {
            display: inline-block;
            white-space: pre;
            content: '';
            color: #4285f4;
          }
        }
      }
    }

    @media (max-width: 992px) {
      width: 100%;

      table,
      thead,
      tbody,
      th,
      td,
      tr {
        display: block;
      }

      thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
      }

      tr {
        border: 1px solid #ccc;
      }

      td {
        border: none;
        border-bottom: 1px solid #eee;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      td:before {
        padding-right: 10px;
        content: attr(data-column);
        color: #000;
        font-weight: bold;
      }
    }
  }
`;

export const FormContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin: 2rem 0rem;

  @media (max-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ActionsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .button {
    position: relative;
    overflow: hidden;
    background: ${props => props.theme.primaryColor};
    color: #fff;
    border-radius: 0.2rem;
    margin-right: 1rem;
    padding: 0.4rem 0.8rem;
    font-size: 1rem;
    border: 1px solid transparent;
    font-weight: 400;
    line-height: 1.25;
    text-transform: uppercase;
    transition: 0.3s ease-in-out;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15),
      0 1px 1px rgba(0, 0, 0, 0.075);

    &:hover {
      background: ${shade(0.2, '#166649')};
    }

    @media (max-width: 768px) {
      font-size: 1rem;
      padding: 0.3rem 1rem;
    }
  }

  .edit {
    background: ${props => props.theme.secondaryColor};

    &:hover {
      background: ${shade(0.2, '#ab934b')};
    }
  }

  .danger {
    background: ${props => props.theme.error};

    &:hover {
      background: ${shade(0.2, '#910f2d')};
    }
  }
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  a {
    background: ${props => props.theme.primaryColor};
    color: #fff;
    border-radius: 0.2rem;
    padding: 0.6rem 1rem;
    font-size: 1rem;
    border: 1px solid #fff;
    font-weight: 400;
    transition: 0.3s ease-in-out;
    position: relative;
    overflow: hidden;

    &:hover {
      background: ${transparentize(0.8, '#fff')};
    }
  }
`;

export const IconButton = styled.svg`
  flex: none;
  transition: fill 0.25s;
  width: 2rem;
  height: 2rem;
`;

export const TitlePage = styled.div`
  margin: 3rem 0;
  h1 {
    font-size: 1.5rem;
    font-weight: 700;
    text-transform: uppercase;
  }
  hr {
    width: 50px;
    border: 3px solid ${props => props.theme.primaryColor};
    background-color: ${props => props.theme.primaryColor};
    border-radius: 4px;
  }
`;

// Paginação

export const Pagination = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const PaginationButton = styled.div`
  display: flex;
`;

interface PGProps {
  isSelect?: boolean;
}

export const PaginationItem = styled.button<PGProps>`
  position: relative;
  overflow: hidden;
  cursor: pointer;
  height: 35px;
  width: 35px;
  border: 1px solid #eceeef;
  color: #979797;
  display: flex;
  margin: 0px 5px;
  border-radius: 5px;
  justify-content: center;
  align-items: center;
  transition: 0.3s ease-in-out;
  background: transparent;

  svg {
    width: 18px;
  }

  :not(:disabled):hover {
    color: ${props => props.theme.secondaryColor};
    border: 1px solid ${props => props.theme.secondaryColor};
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;

    :hover {
      background: transparent;
      color: #979797;
      border: 1px solid #eceeef;
    }
  }
`;

export const FooterTable = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const PageSize = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;

export const LoadingData = styled.div`
  width: 100%;
  margin: 2rem 12px;
`;

export const ReactSelectCustom = styled(ReactSelect)`
  margin-left: 1rem;
  width: 80px;

  .react-select__option {
    background: #fff;
  }

  .react-select__value-container {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    .react-select__single-value {
      color: ${props => props.theme.textColor};
    }
  }

  .react-select__control {
    &:hover,
    &:active,
    &:visited,
    &:focus-visible,
    &:focus-within,
    &:focus {
      border: 1px solid ${props => props.theme.secondaryColor};
      box-shadow: none;
    }
  }

  .react-select__option {
    background: #fff;
    color: ${props => props.theme.textColor};
    display: flex;
    align-items: center;

    &:hover {
      background: ${props => props.theme.primaryColor};
      color: #fff;
      fill: #fff;
    }

    &:hover svg {
      color: #fff;
      fill: #fff;
    }
  }

  .react-select__single-value {
    display: flex;
    align-items: center;
  }
`;
